module.exports = __webpack_public_path__ + "img/login.b95a930a.png";